<div id="container-home-page">
  <div
    class="row justify-content-center align-items-center px-5 pt-5 pb-0 home-page-light-blue-bg-color">
    <div class="col-6 text-center text-black mt-4">
      <h2 class="fw-bold font-size-40">
        Elevate the Resident Experience With Data-Driven Insights
      </h2>
      <p class="my-4 font-size-16">
        Harness the power of person-centered data to create personalized and
        enriched resident experiences.
      </p>
      <a
        class="btn btn-lg schedule-demo-button px-5 text-white mt-3 mb-4"
        href="https://get.tsolife.com/contact-us"
        target="_blank">
        Get Started
      </a>
    </div>
    <div class="col-7 mt-4">
      <img
        class="card-img img-fluid"
        src="assets/images/resident-experiences-page/resident-experiences-hero.png"
        alt="Resident Insights Hero" />
    </div>
  </div>

  <div class="row justify-content-center bg-white mt-0">
    <div class="col-6 text-center text-black mt-5">
      <h2>Reimagining the Resident Experience Landscape</h2>
      <p class="mt-4 font-size-17">
        Utilizing data and insights, our intelligent platform generates
        personalized recommendations for residents via a comprehensive suite of
        engagement tools, encompassing customized inclusivity calendars, digital
        signage, and resident and family communication apps.
      </p>
    </div>
  </div>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row align-items-center invert-sm-order">
      <div class="col-md-5 offset-md-1">
        <div class="card-body mtb-50">
          <h2 class="card-title mb-4 img-info-title titles-color">
            Craft Personalized and Inclusive Activity Calendars
          </h2>
          <p class="card-text img-info-body">
            Our intuitive interface offers unique features such as inclusion
            score tracking, showcasing the number of residents with a known
            interest in the community calendar.
            <br />
            <br />
            By providing activity recommendations aligned with specific Quality
            of Life areas and suggesting events based on residents' interests
            and needs, users can efficiently schedule activities that boost
            resident engagement, saving valuable time and resources in the
            planning process.
          </p>
        </div>
      </div>

      <div class="col-md-5">
        <img
          class="card-img img-fluid"
          src="assets/images/resident-experiences-page/inclusive-activity-calendars.png"
          alt="TSOLife Calendar" />
      </div>
    </div>
  </div>

  <!------>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row">
      <div class="offset-md-1 col-md-5">
        <div class="card-body">
          <img
            class="card-img img-fluid"
            src="assets/images/resident-experiences-page/streamline-digital-signage.png"
            alt="TSOLife Calendar" />
        </div>
      </div>

      <div class="col-md-5 d-flex align-items-center">
        <div class="card-body">
          <h2 class="card-title mb-4 img-info-title titles-color">
            Streamline Digital Signage Management and Control
          </h2>
          <p class="card-text img-info-body">
            Whether you have one display or a hundred, our platform enables
            users to seamlessly scale and control every aspect of their digital
            signage network from one centralized location.
            <br />
            <br />
            With user-friendly features like preloaded templates, synchronized
            activity calendars, and hardware independence, users can enjoy a
            hassle-free experience that enhances both user and resident
            interactions.
          </p>
        </div>
      </div>
    </div>
  </div>

  <!------>

  <div class="card card-home-page-white px-3 py-4">
    <div class="row align-items-center invert-sm-order">
      <div class="col-md-5 offset-md-1">
        <div class="card-body mtb-50">
          <h2 class="card-title mb-4 img-info-title titles-color">
            Create Unified Resident and Family Experiences
          </h2>
          <p class="card-text img-info-body">
            Our resident and family apps are white-labeled and customized to
            align with your community branding, ensuring a unified and cohesive
            experience.
            <br />
            <br />
            Both applications empower residents and family members to message
            community team members, access activity calendars, receive community
            announcements, and more, fostering a sense of involvement for loved
            ones and enhancing the connection for residents.
          </p>
        </div>
      </div>

      <div class="col-md-5">
        <img
          class="card-img img-fluid"
          src="assets/images/resident-experiences-page/family-experiences.png"
          alt="TSOLife Calendar" />
      </div>
    </div>
  </div>

  <div class="row justify-content-center p-5 text-white schedule-demo-bg-color">
    <div class="col-5 my-4">
      <h2 class="text-center">Ready to get started ?</h2>
      <p class="text-center mt-4 font-size-20">
        Get a firsthand look at how our platform is enabling operators to
        deliver exceptional resident experiences and thrive in an ever-evolving
        industry landscape.
      </p>
      <div class="d-flex justify-content-center mt-4">
        <a
          class="btn btn-lg btn-outline-light mx-auto"
          href="https://calendly.com/tsolife-david-sawyer/60min"
          target="_blank">
          Schedule Demo
        </a>
      </div>
    </div>
  </div>
</div>
